import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
import {
    getDiagnosticReportWithImages,
    getDiagnosticResultWithImages,
    saveDiagnosticReportImages,
    saveDiagnosticResultImages,
} from "app/services/DiagnosticReportImageResultService";
import { getFileById } from "app/services/FileDescriptionExtService";
import { getByServiceRequestItemId } from "app/services/DiagnosticReportService";
import { getDiagnosticReportParticipantBySRIId, saveDiagnosticReportParticipants } from "app/services/EncounterParticipantService";

toast.configure({
    autoClose: 2000,
    draggable: false,
    limit: 3,
});

export default class DiagnosticReportParticipantsStore {
    onViewDiagnosticReport = null;

    constructor() {
        makeAutoObservable(this);
    }

    resetStore = () => {
        this.onViewDiagnosticReport = null;
        this.onViewDiagnosticResult = null;
    };

    handleGetDiagnosticReportParticipantBySRIId = async (serviceRequestItemId) => {
        try {
            const { data: diagnosticReportBySRI } = await getDiagnosticReportParticipantBySRIId(serviceRequestItemId);

            this.onViewDiagnosticReport = diagnosticReportBySRI;

        }
        catch (error) {
            console.error(error);
            toast.error("Có lỗi xảy ra khi lấy ảnh thành viên tham gia");
        }
    }

    handleSaveDiagnosticReportParticipants = async (values) => {
        try {
            const { data } = await saveDiagnosticReportParticipants(values);

            toast.success("Đã lưu cập nhật thành viên tham gia");

            return data;
        }
        catch (error) {
            console.error(error);
            toast.error("Có lỗi xảy ra khi cập nhật thành viên tham gia");
        }
    }



}


